import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle groups stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_GROUP)
export class VehicleGroupsStatsDto extends BaseStatsDto {}
